import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import Menu from '@mui/material/Menu'
import MenuItem from './../common/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Dialog from '../../Components/common/Dialog'
import EventIcon from '@mui/icons-material/Event'
import SettingsIcon from '@mui/icons-material/Settings'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
// import { ReactComponent as TimemachineIcon } from '../../assets/nav/time-machine.svg'
import { ReactComponent as TracksIcon } from '../../assets/nav/tracks.svg'
import { ReactComponent as NearestUnitsIcon } from '../../assets/nav/distance-icons.svg'
import { ReactComponent as CommandIcon } from '../../assets/nav/command.svg'
import { ReactComponent as EditIcon } from '../../assets/nav/edit-ico.svg'
// import EditIcon from '@mui/icons-material/Edit';

import { ReactComponent as StreetViewIcon } from '../../assets/nav/street-view.svg'
import { checkPrivileges, prepareStreeView } from '../../Helpers'
import Style from 'style-it'
import { SendCommand } from './../../Pages/Units/Components/sendCommand'
import { ShareLocation } from './../../Pages/Units/Components/ShareLocation'
// import Tracks from '../../Pages/Tracks'
import instance from '../../axios'
import CustomDialog from '../../Components/common/Dialog'
import Table from '../../Components/common/Table'
import NearMeIcon from '@mui/icons-material/NearMe';

import * as turf from '@turf/turf'
import {UpdateAssetTracker} from '../../Pages/Units/Components/updateAssetTracker'
import {Grid, Slider } from '@mui/material'
import { styled } from '@mui/styles'
import CustomTextField from '../common/TextField'
let win;
const PrettoSlider = styled(Slider)(({ownerState }) => ({
  color: ownerState.themecolors?.menuActiveBackground || '#0A83A1',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 22,
    width: 22,
    backgroundColor: ownerState.themecolors?.backgroundColor || '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': { display: 'none' },
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 10,
    background: 'unset',
    padding: 0,
    width: 30,
    height: 30,
    marginTop: 10,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: ownerState.themecolors?.menuActiveBackground || '#0A83A1',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': { transform: 'rotate(45deg)' },
  },
}));



export default class UnitMenu extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      anchorEl: null,
      commandModal: false,
      assetTrackerModal:false,
      openTable:false,
      list: [],
      // sortedDistances:"",
      locationModal: false,
   sortedDistances: [],
  filteredDistances: [],
  minDistance: 0,
  maxDistance: 0,
  sliderRange: [0, 0]

    }
  }

  onCloseModal = () => {
    this.setState(
      {
        commandModal: false,
        locationModal: false,
        assetTrackerModal:false

      },
      () => {
        this.handleClose()
      }
    )
  }

  showModal = ()=> {
    this.fetchData(this.props.data.id)
    this.setState({
      commandModal: true
    })
  }
  
  showAssetTrackerModal=()=>{
    this.setState({
      assetTrackerModal:true
    })
  }
  showLocationModal = () => {
    this.setState({
      locationModal: true
    })
  }
  handleClose = () => {
    this.props.onClose()
  }

  removeDevice = () => {
    this.props.removeDevice(this.props.data)
  }

  editDevice = () => {
    this.props.editDevice(this.props.data)
  }

  handleDeviceSettings = () => {
    this.props.openDeviceSettings()
    this.handleClose()
  }

  componentWillReceiveProps (NextProps) {
    this.setState({ anchorEl: NextProps.anchorEl })
  }

  fetchData = id => {
    this.setState(
      { commandsLoading: true, typesLoading: true, list: [] },
      () => {
        // fetch(`/api/commands/send?deviceId=${id}`, {
        //   method: `GET`,
        //   headers: {
        //     Accept: 'application/json',
        //     'Content-Type': 'application/json'
        //   }
        // })
        instance({
          url: `/api/commands/send`,
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          params:{
            deviceId: id
          }
          })
        // .then(response => {
        //   if (response.ok) {
        //     response.json()
            .then(commands => {
              const list = []
              if (commands.length) {
                commands.map(item => {
                  list.push({ ...item, key: item.id, name: item.description })
                  return null
                })
              }
              this.setState({
                list,
                commandsLoading: false
              })
          //   })
          // }
          // else{
          //   throw response
          // }
        }).catch(() => {
          // errorHandler(error, this.props.dispatch)
        })
      }
    )
  }

  closePrevious = () => {
    win.close();
    win = null;
    this.showStreetView();
  }

  showStreetView = () => {
    if(win && win.closed === false) {
      this.closePrevious()
    }
    else {
      if(this.props.relatedData && this.props.relatedData.exists) {
        win = window.open(prepareStreeView(this.props.relatedData.latitude, this.props.relatedData.longitude),"newWindow");
      }
    }
  }

  onShowTable = ()=> this.setState({openTable:true})
  onCloseTable = ()=> this.setState({openTable:false})

  componentDidMount() {
    this.calculateDistances();
  }

calculateDistances() {
  const relatedLatitude = this.props.relatedData?.latitude;
  const relatedLongitude = this.props.relatedData?.longitude;

  const distances = Object.values(this.props.deviceRelatedData || {}).map(device => {
    if (!device) return null;

    const deviceLatitude = device.latitude;
    const deviceLongitude = device.longitude;

    if (
      relatedLatitude && relatedLongitude &&
      deviceLatitude && deviceLongitude &&
      device.id !== this.props.relatedData.id
    ) {
      const point1 = turf.point([Number(relatedLongitude), Number(relatedLatitude)]);
      const point2 = turf.point([Number(deviceLongitude), Number(deviceLatitude)]);
      const distance = turf.distance(point1, point2);

      return {
        deviceId: device.id,
        distance: Math.ceil(distance),
        name: device.name,
        status: device.status,
      };
    }

    return null;
  });

  const valid = distances.filter(v => v !== null);
  const sorted = valid.sort((a, b) => a.distance - b.distance);

  if (sorted.length === 0) return;

  const minDistance = sorted[0].distance;
  const maxDistance = sorted[sorted.length - 1].distance;

  this.setState(
    {
      sortedDistances: sorted,
      filteredDistances: sorted,
      minDistance,
      maxDistance,
      sliderRange: [minDistance, maxDistance]
    },
    () => this.filterByDistance()
  );
}

filterByDistance = () => {
  const { sortedDistances, sliderRange } = this.state;

  const [min, max] = sliderRange;

  const filtered = sortedDistances.filter(d =>
    d.distance >= min && d.distance <= max
  );

  this.setState({ filteredDistances: filtered });
};



handleSliderChange = (e, newValue) => {
  this.setState(
    { sliderRange: newValue },
    () => this.filterByDistance()
  );
};


  handleMinChange = (e) => {
    const newMin = Number(e.target.value);
    this.setState((prev) => {
      let [, max] = prev.value;
      return { value: [Math.min(newMin, max - 1), max] };
    });
  };

  handleMaxChange = (e) => {
    const newMax = Number(e.target.value);
    this.setState((prev) => {
      let [min] = prev.value;
      return { value: [min, Math.max(newMax, min + 1)] };
    });
  };

  render () {
    const styles = {
      ListItemIcon: {
        fontSize: 18,
        fill: 'currentColor'
      },
      ListItemIconWrap: {
        marginRight: 10,
        color: 'inherit',
        minWidth: 18
      }
    }
    return (
      <Style>
        {`
    .custom-menu-paper {
      background: ${this.props.themecolors.backgroundColor};
      color: ${this.props.themecolors.textColor}
    }
    `}
        <div>
          <Menu
            id={this.props.id}
            anchorEl={this.props.anchorEl}
            open={Boolean(this.props.anchorEl)}
            onClose={this.handleClose}
            classes={{ paper: 'custom-menu-paper' }}
          >
            {checkPrivileges('device') && (
              <MenuItem
                component={Link}
                to={'/events/' + this.props.data.id}
                onClick={this.handleClose}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <EventIcon style={styles.ListItemIcon} />
                </ListItemIcon>
                {this.props.translate('eventHistory')}
              </MenuItem>
            )}
            {checkPrivileges('track') && (
              <MenuItem
                component={Link}
                to={'/tracks/'+ this.props.data.id}
                onClick={this.handleClose}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <TracksIcon
                    width={14}
                    height={14} 
                    style={styles.ListItemIcon} />
                </ListItemIcon>
                {this.props.translate('Tracks')}
              </MenuItem>
            )}
              {/* {checkPrivileges('track') && ( */}
              <MenuItem
                component={Link}
                style={styles.MenuItem}
                // to={'/tracks/'+ this.props.data.id}
                to={"#"}
                onClick={this.onShowTable}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <NearestUnitsIcon
                    width={14}
                    height={14} 
                    
                    style={styles.ListItemIcon} />
                </ListItemIcon>
                {this.props.translate('Nearest Units')}
              </MenuItem>
            {/* )} */}
            {checkPrivileges('deviceUpdate') && (
              <MenuItem
                component='li'
                style={styles.MenuItem}
                onClick={this.handleDeviceSettings}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <SettingsIcon style={styles.ListItemIcon} />
                </ListItemIcon>
                {this.props.translate('openDeviceSettings')}
              </MenuItem>
            )}
            {checkPrivileges('report') && (
              <MenuItem
                component={Link}
                to='/reports'
                style={styles.MenuItem}
                onClick={this.handleClose}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <InsertDriveFileIcon style={styles.ListItemIcon} />
                </ListItemIcon>
                {this.props.translate('openReports')}
              </MenuItem>
            )}
            {checkPrivileges('command') ? (
              <MenuItem
                component='li'
                style={styles.MenuItem}
                onClick={this.showModal}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <CommandIcon
                    width={14}
                    height={14}
                    style={styles.ListItemIcon}
                  />
                </ListItemIcon>
                {this.props.translate('sendCommand')}
              </MenuItem>
            ) : null}
            {this.props.data?.model==="FX Asset" ? (
              <MenuItem
                component='li'
                style={styles.MenuItem}
                onClick={this.showAssetTrackerModal}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <EditIcon
                    width={14}
                    height={14}
                    style={{fill: "currentColor", position: "relative", top: 2}}
                  />
                </ListItemIcon>
                {this.props.translate('addNewSurvey')}
              </MenuItem>
            ) : null}
             {checkPrivileges('deviceLocSharing') ? (
              <MenuItem
                component='li'
                style={styles.MenuItem}
                onClick={this.showLocationModal}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <NearMeIcon
                    width={14}
                    height={14}
                    style={styles.ListItemIcon}
                  />
                </ListItemIcon>
                {this.props.translate('shareLocation')}
              </MenuItem>
             ): null}
            {this.props.relatedData && this.props.relatedData.exists ? (
              <MenuItem
                component='li'
                style={styles.MenuItem}
                onClick={this.showStreetView}
              >
                <ListItemIcon style={styles.ListItemIconWrap}>
                  <StreetViewIcon
                    width={14}
                    height={14}
                    style={styles.ListItemIcon}
                  />
                </ListItemIcon>
                
                {this.props.translate('streetView')}
              </MenuItem>
            ) : null}
          </Menu>

          {this.state.openTable ? <>
            <CustomDialog
                // title={this.props.item?.name||""}
                title={this.props.translate('Devices Locations')}
                themecolors={this.props.themecolors}
                visable={true}
                onClose={this.onCloseTable}
                bodyPadding={10}
                isVisableBtn
                noFullScreen
              >
<Grid container spacing={2} alignItems="center" my={0.5}>
  <Grid item xs={4}>
    <CustomTextField
      label="Min Distance"
      type="number"
      fullWidth
      value={this.state.sliderRange[0]}
      onChange={(e) => {
        const newMin = Math.max(0, Number(e.target.value));
        this.setState(prev => ({
          sliderRange: [
            Math.min(newMin, prev.sliderRange[1] - 1),
            prev.sliderRange[1]
          ],
          minDistance: newMin < prev.minDistance ? newMin : prev.minDistance
        }), this.filterByDistance);
      }}
    />
  </Grid>
  <Grid item xs={4}>
    <PrettoSlider
      value={this.state.sliderRange}
      min={this.state.minDistance}
      max={this.state.maxDistance}
     ownerState={{themecolors:this.props.themecolors }}
      onChange={(e, newValue) => this.setState({ sliderRange: newValue }, this.filterByDistance)}
      valueLabelDisplay="auto"
    />
  </Grid>
  <Grid item xs={4}>
    <CustomTextField
      label="Max Distance"
      type="number"
      fullWidth
      value={this.state.sliderRange[1]}
      onChange={(e) => {
        const newMax = Number(e.target.value);
        this.setState(prev => ({
          sliderRange: [
            prev.sliderRange[0],
            Math.max(newMax, prev.sliderRange[0] + 1)
          ],
          maxDistance: newMax > prev.maxDistance ? newMax : prev.maxDistance
        }), this.filterByDistance);
      }}
    />
  </Grid>
</Grid>

                <Table insideDialog={true}
                    title={this.props.translate('Devices Locations')}
                    rows={this.state.filteredDistances||[]}
                    rowsPerPage={10}
                    searchable={false}
                    themecolors={this.props.themecolors} 
                    rowDefinition={[
                        { id: 'name', numeric: false, disablePadding: false, label: this.props.translate('sharedName') },
                        { id: 'distance', type: "any", numeric: false, label: this.props.translate('distance') + ' (Km)' },
                        { id: 'status', type: "any", numeric: false, label: this.props.translate('status') },
                    ]} />
                      </CustomDialog>
        </>: null}
          {this.state.commandModal ? (
            <Dialog
              open
              // title={this.props.translate('sendCommand')}
              title={`${this.props.translate('sendCommand')} ${'  '}${this.props.data.name}`}

              themeColors={this.props.themecolors}
              disableFooter
              onClose={this.onCloseModal}
              dialogHeight={250}
              draggable
              bodyPadding={0}
            >
              <SendCommand
                id={this.props.id}
                dispatch={this.props.dispatch}
                translate={this.props.translate}
                themecolors={this.props.themecolors}
                descriptionList={this.state.list}
              />
            </Dialog>
          ) : null}

                 {this.state.assetTrackerModal ? (
            <Dialog
              open
              // title={this.props.translate('sendCommand')}
              title={`${this.props.translate('addNewSurvey')} ${'  '}${this.props.data.name}`}

              themeColors={this.props.themecolors}
              disableFooter
              onClose={this.onCloseModal}
              dialogHeight={250}
              draggable
              bodyPadding={0}
            >
              <UpdateAssetTracker
                id={this.props.id}
                dispatch={this.props.dispatch}
                translate={this.props.translate}
                themecolors={this.props.themecolors}
                device={this.props.data}
                onCloseModal={this.onCloseModal}
              />
            </Dialog>
          ) : null}
          {this.state.locationModal ? (
            <Dialog
              open
              // title={this.props.translate('sendCommand')}
              title={`${this.props.translate('shareLocation')}${'  '} ${this.props.translate('of')} ${'  '}  ${this.props.data.name}`}

              themeColors={this.props.themecolors}
              disableFooter
              onClose={this.onCloseModal}
              dialogHeight={250}
              draggable
              bodyPadding={0}
            >
              <ShareLocation
                device={this.props.data}
                id={this.props.id}
                ServerSetting={this.props.ServerSetting}
                dispatch={this.props.dispatch}
                translate={this.props.translate}
                themecolors={this.props.themecolors}
                descriptionList={this.state.list}
                logInUser={this.props.logInUser}
                copyToClipboard={this.props.copyToClipboard}s
              />
            </Dialog>
          ) : null}
        </div>
      </Style>
    )
  }
}
